<template>
  <div class="plv-iar-product pws-aside-bg-color pws-iar-product-list-wrap">
    <div
      ref="productContent"
      class="plv-iar-product__content pws-iar-product-list-content pws-chat-scroll-color"
      @scroll="handleScroll"
    >
      <div class="plv-iar-product__top">
        <!-- 标签选择 -->
        <pc-label-list v-model="currentTagId" :product-sdk="productSdk" />
        <!-- 总数 -->
        <product-total v-if="totalVisible && products.length" :total="total" />
      </div>

      <template v-if="products.length">
        <!-- 列表 -->
        <product-item
          v-for="(good) in products"
          :key="good.productId"
          ref="productItem"
          :number="good.showId"
          :good="good"
          :hide-number="!!currentTagId"
          :content-width="contentWidth"
          @job-detail="clickJobDetail"
        />
      </template>
      <template v-else>
        <product-empty />
      </template>
    </div>
  </div>
</template>

<script>
import mixin from './mixin';
import ProductEmpty from '../../components/product/list/ProductEmpty.vue';
import ProductTotal from '../../components/product/list/ProductTotal.vue';
import ProductItem from '../../components/product/list/ProductItem.vue';
import PcLabelList from './components/label-list/PcLabelList.vue';

export default {
  components: {
    ProductEmpty,
    ProductTotal,
    ProductItem,
    PcLabelList,
  },

  mixins: [mixin],
};
</script>

<style lang="scss">
@import '../../assets/styles/basic';

.plv-iar-product {
  width: 100%;
  height: 100%;
  position: relative;
  background: #202127;
  box-sizing: border-box;
}

.plv-iar-product__content {
  width: 100%;
  height: 100%;
  padding: 0 16px;
  position: relative;
  box-sizing: border-box;
  background-color: #1a1a1f;
  overflow-y: auto;
  @include scrollbar(inherit, inherit, #46464f, inherit);
  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 8px;
  }
}
.plv-iar-product__top {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 30;
  background-color: inherit;
}
</style>
